import { render, staticRenderFns } from "./catModel.vue?vue&type=template&id=ce4f920c&scoped=true"
import script from "./catModel.vue?vue&type=script&lang=js"
export * from "./catModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce4f920c",
  null
  
)

export default component.exports